module.exports = __webpack_public_path__ + "media/images/webpage/hotels/9494/nami-c845e403ac41dac1495b1da05edb7e47.webp";